module.exports = __webpack_public_path__ + "static/media/guilherme.b5003194.jpg";